import * as React from "react";
const IconRemove = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17}
    height={17}
    fill="none"
    {...props}
  >
    <path
      stroke={props.color || "#4F4FFF"}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M13.5 8.5h-10"
    />
  </svg>
);
export default IconRemove;
